// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./bower_components/fancybox/dist/jquery.fancybox.min.css
// module id = 21
// module chunks = 0